async function addMarkerImagesToMap(maplibreMap) {
  const imgModules = import.meta.glob('/src/img/maptiler/markers/*.png', {
    eager: false,
    as: 'url',
  });

  await Promise.all(
    Object.keys(imgModules).map(async (filePath) => {
      const fileName = filePath.split('/').pop();
      const imgUrl = await imgModules[filePath]();
      const image = await maplibreMap.loadImage(imgUrl);
      maplibreMap.addImage(
        `nazka_${fileName.replace(/\.[^/.]+$/, '')}`,
        image.data,
        { sdf: fileName.startsWith('sdf-') },
      );
    }),
  );
}

export { addMarkerImagesToMap };
